import clsx from 'clsx'
import type { ReactNode } from 'react'

import { Card, CardBody, CardHeader } from '@/src/elements/card'
import { Typography } from '@/src/elements/text/Typography'
import { formatNl } from '@/src/general/primitives/strings'

import type { TCommunityPrayerProps } from './CommunityPrayer.types'

export const CommunityPrayer = ({
  classNames,
  prayerContent,
  prayerName,
  ...otherProps
}: TCommunityPrayerProps): ReactNode => (
  <Card
    shadow="xs"
    classNames={{
      ...classNames,
      base: clsx(
        'gap-6 border border-solid border-layout-stroke-contrast-low bg-gradient-to-b from-primary-gradient-light-from to-primary-gradient-light-to p-6',
        classNames?.base,
      ),
      body: clsx('mx-auto max-w-md', classNames?.body),
    }}
    {...otherProps}
  >
    <CardHeader>
      <Typography heading="h2" className="text-center font-black" colors="primary" size="xl">
        {prayerName}
      </Typography>
    </CardHeader>

    <CardBody>
      {/** TODO: Fix using className 'text-mdlc' instead of size="mdlc" which causes an error */}
      <Typography className="whitespace-pre-line text-center text-mdlc" colors="primary" contrast="high">
        {formatNl(prayerContent)}
      </Typography>
    </CardBody>
  </Card>
)
